let _cache = {};

const _get = key => {
  return _cache[key];
};

const _set = (key, value) => {
  _cache[key] = value;
};

const _reset = () => {
  _cache = {};
};

module.exports = {
  get: _get,
  set: _set,
  clear: _reset
};



// WEBPACK FOOTER //
// ./common/cache.js